var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSdkLeftStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223 45"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "sdk-left-stars_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#487FCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "98.963%",
    y2: "50%",
    id: "sdk-left-stars_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.678,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.542
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sdk-left-stars_svg__a)",
    width: 164,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sdk-left-stars_svg__b)",
    x: 134,
    y: 38,
    width: 89,
    height: 7,
    rx: 3.5
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjIzcHgiIGhlaWdodD0iNDVweCIgdmlld0JveD0iMCAwIDIyMyA0NSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDx0aXRsZT5Hcm91cCAzMDwvdGl0bGU+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgeDE9IjAlIiB5MT0iNTAlIiB4Mj0iMTAwJSIgeTI9IjUwJSIgaWQ9ImxpbmVhckdyYWRpZW50LTEiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjMEUxOTMyIiBzdG9wLW9wYWNpdHk9IjAuMzg3OTc1MzA2IiBvZmZzZXQ9IjAlIj48L3N0b3A+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiM0ODdGQ0YiIG9mZnNldD0iMTAwJSI+PC9zdG9wPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSIwJSIgeTE9IjUwJSIgeDI9Ijk4Ljk2MjczMjMlIiB5Mj0iNTAlIiBpZD0ibGluZWFyR3JhZGllbnQtMiI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwRTE5MzIiIHN0b3Atb3BhY2l0eT0iMC4zODc5NzUzMDYiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0ZGRkZGRiIgc3RvcC1vcGFjaXR5PSIwLjY3NzUyOTUwMiIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIG9wYWNpdHk9IjAuNTQyMzY0MjExIj4KICAgICAgICA8ZyBpZD0iMjAyMV9Ib21lcGFnZVJlZnJlc2giIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNjcuMDAwMDAwLCAtMTkwMS4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTMwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjcuMDAwMDAwLCAxOTAxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1Db3B5LTkiIGZpbGw9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjQiIGhlaWdodD0iNyIgcng9IjMuNSI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1Db3B5LTExIiBmaWxsPSJ1cmwoI2xpbmVhckdyYWRpZW50LTIpIiB4PSIxMzQiIHk9IjM4IiB3aWR0aD0iODkiIGhlaWdodD0iNyIgcng9IjMuNSI+PC9yZWN0PgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgSdkLeftStars as ReactComponent };